export default __webpack_public_path__ + "static/media/plain-sticker-t.4fc9c61e.png";